import styled from "styled-components";
import WhiteBox from "../WhiteBox";
import { colors } from "../../styles";
import TalkToAgentButton from "components/TalkToAgent";

const SecretCard = ({ title, body, image, highlights, disclaimer }) => {
  return (
    <WhiteBox onClick={(e) => e.stopPropagation()}>
      {image && <img src={image} alt={title} style={{ width: "100%" }} />}
      <Wrapper>
        <Title className="text-center">{title}</Title>

        <p>{body}</p>

        {highlights && (
          <List>
            {highlights.map((description, i) => (
              <ListItem key={`plan-description-${i}`}>{description}</ListItem>
            ))}
          </List>
        )}

        <p>{disclaimer}</p>
      </Wrapper>

      <div
        style={{
          padding: 10,
          textAlign: "center",
        }}
      >
        <TalkToAgentButton
          buttonProps={{
            $type: "primary",
            children: "Consulta gratis hoy",
          }}
        />
      </div>

      <CustomBottom />
    </WhiteBox>
  );
};

SecretCard.defaultProps = {
  buttonText: "Reparar Mi Credito",
};

export default SecretCard;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  padding: 10px 15px;
  text-align: center;

  &,
  * {
    user-select: none;
  }
`;

const CustomBottom = styled.div`
  width: 100%;
  height: 0.5rem;
  background-color: ${colors.blue};
  margin-top: 0.5rem;
`;

const List = styled.ul`
  list-style: none;
  text-align: left;
`;

const ListItem = styled.li`
  padding-left: 1em;
  text-indent: -1em;
  margin: 5px 0;
  font-size: 1.2em;

  &:before {
    color: ${colors.red};
    content: "x ";
  }
`;

const Title = styled.h1`
  padding: 10px 0;
`;
